import { WidthType, BorderStyle, Paragraph, TextRun, HeadingLevel, AlignmentType, ShadingType, Table, TableRow, TableCell } from "docx";
import { IsJsonString } from "@/utils/json";

function convertTrelloCards(boardName, listeName, cards, developers) {
  var content = [];

  // Paramètrage général
  const docFont = 'Calibri';
  var today = new Date();
  var day = today.getDate() < 10 ? "0" + today.getDate().toString() : today.getDate().toString();
  var month = (today.getMonth() + 1) < 10 ? "0" + (today.getMonth() + 1).toString() : (today.getMonth() + 1).toString();
  var datetime = day + "/" + month + "/" + today.getFullYear().toString()
  var projectName = boardName.replaceAll("Suivi ", "").replaceAll(".", " ").toUpperCase();
  var tableSpacing = 100;
  var tableShading = {
    type: ShadingType.PERCENT_95,
    color: "cccccc",
    fill: "cccccc",
  };

  // On crée le titre du document
  var heading = new Paragraph({
    heading: HeadingLevel.TITLE,
    alignment: AlignmentType.CENTER,
    children: [
      new TextRun({
        text: projectName,
        font: "Calibri Light",
        size: 52,
        color: "70ad47",
      })
    ]
  });
  content.push(heading);

  // On crée le sous-titre du document
  var subheading = new Paragraph({
    heading: HeadingLevel.HEADING_2,
    alignment: AlignmentType.CENTER,
    children: [
      new TextRun({
        text: ("Fiche de livraison - " + listeName.replace("Livraison ", "")).toUpperCase(),
        font: "Calibri Light",
        size: 52,
        color: "000000",
      })
    ]
  });
  content.push(subheading);

  // Saut de ligne
  content.push(createParagraphWithTextRun(" ", docFont));

  // On ajoute le tableau des informations
  content.push(new Table({
    rows: [
      new TableRow({
        children: [
          new TableCell({
            width: {
              size: 4505,
              type: WidthType.DXA,
            },
            children: [createParagraphWithTextRun('  Date : ', docFont, tableSpacing) ],
          }),
          new TableCell({
            width: {
              size: 4505,
              type: WidthType.DXA,
            },
            children: [createParagraphWithTextRun(datetime, docFont, tableSpacing, "right")],
          }),
        ]
      }),
      new TableRow({
        children: [
          new TableCell({
            shading: tableShading,
            children: [createParagraphWithTextRun('  Projet : ', docFont, tableSpacing)],
          }),
          new TableCell({
            shading: tableShading,
            children: [createParagraphWithTextRun(projectName, docFont, tableSpacing, "right")],
          }),
        ]
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [createParagraphWithTextRun('  Développeur(s) : ', docFont, tableSpacing)],
          }),
          new TableCell({
            children: [createParagraphWithTextRun(developers, docFont, tableSpacing, "right")],
          }),
        ]
      }),
      new TableRow({
        children: [
          new TableCell({
            shading: tableShading,
            children: [createParagraphWithTextRun('  Concerne : ', docFont, tableSpacing)],
          }),
          new TableCell({
            shading: tableShading,
            children: [createParagraphWithTextRun("Interne", docFont, tableSpacing, "right")],
          }),
        ]
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [createParagraphWithTextRun('  Référence :', docFont, tableSpacing)],
          }),
          new TableCell({
            children: [createParagraphWithTextRun(projectName.replace("CMEM", "").replace(" ", "") + "-FDL-" + listeName.replace("Livraison ", ""), docFont, tableSpacing, "right")],
          }),
        ]
      }),
    ]
  }));

  /// Saut de page
  content.push(new Paragraph({
    pageBreakBefore: true,
    children: [
      new TextRun({
        text: "",
      }),
    ]
  }));

  // On remplit le corps
  cards.forEach(c => {
    // Titre de la tâche
    var cardHeading = new Paragraph({
      // Font au titre de la carte
      shading: {
        type: ShadingType.PERCENT_95,
        color: "70ad47",
        fill: "70ad47",
      },
      spacing: {
        line: 300,
      },
      children: [
        new TextRun({
          text: "#" + c.id + " - " + c.name.toUpperCase(),
          font: docFont,
          color: "FFFFFF",
          size: 22,
        })
      ],

    });
    content.push(cardHeading);

    // Description de la tâche
    if (c.description) {
      let desc = c.description;
      if (IsJsonString(c.description))
        desc = JSON.parse(c.description).description;
      content.push(createParagraphWithTextRun(desc, docFont));
    }

    // Saut de ligne
    content.push(createParagraphWithTextRun(" ", docFont));

    // Classification
    if (c.labels != "") {
      content.push(new Table({
        rows: [
          new TableRow({
            children: [
              new TableCell({
                width: {
                  size: 4505,
                  type: WidthType.DXA,
                },
                children: [createParagraphWithTextRun('  Classification : ', docFont, tableSpacing)],
              }),
              new TableCell({
                width: {
                  size: 4505,
                  type: WidthType.DXA,
                },
                children: [createParagraphWithTextRun(c.labels, docFont, tableSpacing, "right")],
              }),
            ]
          }),
        ]
      }));
    }

    // Assignement
    if (c.members != "") {
      content.push(new Table({
        rows: [
          new TableRow({
            children: [
              new TableCell({
                width: {
                  size: 4505,
                  type: WidthType.DXA,
                },
                shading: tableShading,
                children: [createParagraphWithTextRun('  Réalisé par : ', docFont, tableSpacing)],
              }),
              new TableCell({
                width: {
                  size: 4505,
                  type: WidthType.DXA,
                },
                shading: tableShading,
                children: [createParagraphWithTextRun(c.members, docFont, tableSpacing, "right")],
              }),
            ]
          }),
        ]
      }));
    }

    // Saut de ligne
    content.push(createParagraphWithTextRun(" ", docFont));
  });


  return content;
}


function createParagraphWithTextRun(textValue, fontValue, spacing = 0, align = "", shading = null) {
  // Espacement des paragraphes
  var space = {
    before: 0
  };
  if (spacing != 0) {
    space.before = spacing;
  }

  // Alignement du texte
  var alignment = AlignmentType.LEFT;
  switch (align) {
    case "left":
      var alignment = AlignmentType.LEFT;
      break;
    case "center":
      var alignment = AlignmentType.CENTER;
      break;
    case "right":
      var alignment = AlignmentType.RIGHT;
      break;
    default:
      break;
  }

  // couleur de fond
  var shade = {};
  if (shading != null) {
    shade = shading;
  }

  return new Paragraph({
    children: [
      new TextRun({
        text: textValue,
        font: fontValue,
      }),
    ],
    spacing: space,
    alignment: alignment,
    shading: shade
  });
}

export default { convertTrelloCards };
export { convertTrelloCards };



// WEBPACK FOOTER //
// ./src/helpers/trelloCardToWordConverter.js